module.exports = __webpack_public_path__ + "static/media/GitHub_Logo@2x.51869b1a.png";